import { render, staticRenderFns } from "./SaleSummary.vue?vue&type=template&id=b8afc642"
import script from "./SaleSummary.vue?vue&type=script&lang=js"
export * from "./SaleSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/185/185admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b8afc642')) {
      api.createRecord('b8afc642', component.options)
    } else {
      api.reload('b8afc642', component.options)
    }
    module.hot.accept("./SaleSummary.vue?vue&type=template&id=b8afc642", function () {
      api.rerender('b8afc642', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/admin/components/PanelGroup/SaleSummary.vue"
export default component.exports